import SpinnerButton from 'src/components/Common/@electron/SpinnerButton';
import {
  ButtonProps,
  ContinueButtonProps,
  FormStepButtonsProps,
  PreviousCancelButtonsProps,
} from '../types';

export const PreviousButton = ({
  hasDarkBackground = false,
  handleClick,
  buttonText = 'Previous',
}: ButtonProps) => {
  return (
    <button
      className={`btn btn-md ${
        hasDarkBackground ? 'btn-secondary-reversed btn-full sm:btn-auto' : 'btn-secondary'
      }`}
      onClick={handleClick}
      type="button"
    >
      {buttonText}
    </button>
  );
};

export const CancelButton = ({
  handleClick,
  hasDarkBackground,
  buttonText = 'Cancel',
}: ButtonProps) => {
  return (
    <button
      className={`btn btn-md btn-tertiary bg-transparent hover:bg-transparent hover:underline ${
        hasDarkBackground ? 'text-white hover:text-white' : ''
      }`}
      onClick={handleClick}
      type="button"
    >
      {buttonText}
    </button>
  );
};

export const ContinueButton = ({
  handleClick,
  buttonText = 'Continue',
  isPending = false,
  isDisabled = false,
}: ContinueButtonProps) => {
  return (
    <SpinnerButton
      isSpinning={isPending}
      buttonText={buttonText}
      screenReaderText={isPending ? 'Currently processing your request' : buttonText}
      onClick={handleClick}
      className={`btn-md ${isDisabled ? 'opacity-40 pointer-events-none' : ''}`}
      type="submit"
      aria-disabled={isDisabled}
    />
  );
};

export const PreviousCancelButtons = ({
  handleCancelClick,
  handlePreviousClick,
  previousButtonText,
  cancelButtonText,
}: PreviousCancelButtonsProps) => (
  <div className="mb-48 flex flex-col gap-8 items-center">
    <PreviousButton
      hasDarkBackground={true}
      handleClick={handlePreviousClick}
      buttonText={previousButtonText}
    />
    <CancelButton
      handleClick={handleCancelClick}
      hasDarkBackground={true}
      buttonText={cancelButtonText}
    />
  </div>
);

export const FormStepButtons = ({
  handleCancelClick,
  handleContinueClick,
  handlePreviousClick,
  previousButtonText,
  cancelButtonText,
  continueButtonText,
  isPending,
  isContinueButtonDisabled = false,
}: FormStepButtonsProps) => {
  return (
    <div className="text-center">
      <div className="w-full flex flex-row justify-center gap-18">
        <PreviousButton
          handleClick={handlePreviousClick}
          buttonText={previousButtonText}
          hasDarkBackground={false}
        />
        <ContinueButton
          handleClick={handleContinueClick}
          buttonText={continueButtonText}
          isPending={isPending}
          isDisabled={isContinueButtonDisabled}
        />
      </div>
      <CancelButton
        hasDarkBackground={false}
        handleClick={handleCancelClick}
        buttonText={cancelButtonText}
      />
    </div>
  );
};
